"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Palette is based on a color from the secondary colors in
 * mnemonic design manual
 * This palette is the same as the green color
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const tertiary5 = {
    50: "#E8F4EC",
    100: "#C7E4D1",
    200: "#A4D3B4",
    300: "#80C397",
    400: "#66B682",
    500: "#4DAA6D",
    600: "#459B63",
    700: "#3D8957",
    800: "#36784C",
    900: "#2C583A",
    A100: "#C7E4D1",
    A200: "#80C397",
    A400: "#4DAA6D",
    A700: "#36784C",
};
exports.default = tertiary5;
